<template>
  <span class="apphome" style="padding:0">
    <div class="apphome_box" style="padding:0">

      <span style="margin-bottom:12px;display:flex;">
        <el-button type="primary" @click="handleExportHistoryExcel">导出</el-button>
        <el-popover placement="top" width="360" v-model="visible">
          <el-upload class="upload-demo" drag action="http://127.0.0.1:19000/manualInputVariable/importHistoryExcel"
            multiple :on-success="handleUploadSuccess">
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
            <!-- <div class="el-upload__tip" slot="tip">只能上传jpg/png文件，且不超过500kb</div> -->
          </el-upload>
          <el-button style="margin-left:10px" slot="reference" type="primary">导入</el-button>
        </el-popover>
        <el-button style="margin-left:10px" type="primary" @click="handleUpdateHistoryValue">更新到历史库</el-button>
        <el-button type="primary" @click="handleToAccumulateValue">差值转换成累加值</el-button>
        <el-button type="primary" @click="handleAvgByStartAndNext">根据首尾自动平均</el-button>
        <el-button type="primary" @click="handleStartTwoValueToAdd">根据两值自动增量</el-button>
        <el-button type="primary" @click="getList">刷新</el-button>
        <el-input style="width:200px;margin-left: auto;" placeholder="请输入变量名称" v-model="queryInput" clearable>
        </el-input>
      </span>

      <el-tabs type="border-card" v-model="activeName">
        <el-tab-pane label="日数据" name="historyex">
          <span class="box">
            时间
            <span>
              <el-date-picker v-model="value1" type="date" size="mini" placeholder="选择日期" value-format="yyyy-MM-dd">
              </el-date-picker>
            </span>
          </span>
          <span class="box">
            间隔(分钟)
            <span class="radio_box">
              <el-radio v-model="timeInterval" :label="0">5</el-radio>
              <el-radio v-model="timeInterval" :label="1">15</el-radio>
              <el-radio v-model="timeInterval" :label="2">30</el-radio>
              <el-radio v-model="timeInterval" :label="3">60</el-radio>
            </span>
          </span>
          <el-table id="demo" v-loading="loading" ref="table"
            :header-cell-style="{ color: '#333', fontFamily: 'MicrosoftYaHeiUI', fontSize: '14px', fontWeight: 900, backgroundColor: '#f5f7fa' }"
            stripe :data="tableData" border style="width: 100%" @selection-change="handleSelectionChange">
            <template slot="empty">
              <span class="noData">
                <img src="../../assets/noData.png" alt="暂无数据">
                <span class="text">暂无数据</span>
              </span>
            </template>
            <el-table-column type="selection" width="50" align="center" fixed />

            <el-table-column v-for="(item, index) in columns" :key='index' :label="item.name" :align="item.al"
              v-if="item.show" :fixed="item.fixed" :minWidth="item.width">
              <template slot-scope="scope">

                <input ref="input" v-if="flag == (item.key + scope.$index)" v-model.lazy="scope.row[item.key]"
                  @blur="flag = ''" autofocus class="el-input__inner" type="number"
                  style="height: 28px;line-height: 28px;">
                <span v-else @click="row_fn(item.key, scope.$index)">{{ scope.row[item.key] }}</span>

              </template>
            </el-table-column>

          </el-table>
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page="currentPage" :page-sizes="[10, 20, 30, 50]" :page-size="currentSize"
            layout="total, sizes, prev, pager, next, jumper" :total="total" style="margin-top: 15px;">
          </el-pagination>
        </el-tab-pane>
        <el-tab-pane label="月数据" name="historyday">
          <span class="box">
            日期:
            <el-date-picker v-model="value2" type="month" placeholder="选择月" value-format="yyyy-MM-dd">
            </el-date-picker>
          </span>
          <el-table id="demo" ref="table2" v-loading="loading"
            :header-cell-style="{ color: '#333', fontFamily: 'MicrosoftYaHeiUI', fontSize: '14px', fontWeight: 900, backgroundColor: '#f5f7fa' }"
            stripe :data="tableData" border style="width: 100%" @selection-change="handleSelectionChange">
            <template slot="empty">
              <span class="noData">
                <img src="../../assets/noData.png" alt="暂无数据">
                <span class="text">暂无数据</span>
              </span>
            </template>
            <el-table-column type="selection" width="50" align="center" fixed />
            <el-table-column v-for="(item, index) in columns2" :key='index' :label="item.name" :align="item.al"
              :fixed="item.fixed" :minWidth="item.width">
              <template slot-scope="scope">
                <input v-if="flag2 == (item.key + scope.$index)" v-model.lazy="scope.row[item.key]" @blur="flag2 = ''"
                  autofocus class="el-input__inner" type="number" style="height: 28px;line-height: 28px;">
                <span v-else @click="row_fn2(item.key, scope.$index)">{{ scope.row[item.key] }}</span>

              </template>
            </el-table-column>
          </el-table>
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page="currentPage" :page-sizes="[10, 20, 30, 50]" :page-size="currentSize"
            layout="total, sizes, prev, pager, next, jumper" :total="total" style="margin-top: 15px;">
          </el-pagination>
        </el-tab-pane>
      </el-tabs>
    </div>
  </span>
</template>
<script>

  export default {

    data () {

      return {
        queryInput: '',
        total: 0,
        currentPage: 1,
        currentSize: 10,
        visible: false,
        flag: '',//需要显示的key+索引 日
        flag2: '',//需要显示的key+索引 月
        multipleSelection: [],
        activeName: 'historyex',
        loading: false,
        value1: this.parseTime(new Date()),
        value2: this.parseTime(new Date(),'{y}-{m}'),
        timeInterval: 0,//间隔时间
        list: '',

        tableData: [],
        showHour: true,
        showHalfHour: true,
        showQuarterHour: true,
        showTwelfthHour: true
      };
    },

    computed: {
      columns () {
        let list=[];
        list.push({name: '变量名称',key: 'variablename',al: 'left',width: 400,fixed: true,show: true})
        list.push({name: '日',key: 'day',al: 'center',width: 50,fixed: true,show: true})
        list.push({name: 'next',key: 'next',al: 'center',width: 160,fixed: false,show: true})
        for(let i=0;i<24;i++) {
          for(let j=0;j<59;j+=5) {
            if(j===0) {
              list.push({name: 'value'+(i+'').padStart(2,0)+(j+'').padStart(2,0),key: 'value'+(i+'').padStart(2,0)+(j+'').padStart(2,0),al: 'center',width: 160,fixed: false,show: this.showHour})
            } else if(j===30) {
              list.push({name: 'value'+(i+'').padStart(2,0)+(j+'').padStart(2,0),key: 'value'+(i+'').padStart(2,0)+(j+'').padStart(2,0),al: 'center',width: 160,fixed: false,show: this.showHalfHour})
            }
            else if(j===15) {
              list.push({name: 'value'+(i+'').padStart(2,0)+(j+'').padStart(2,0),key: 'value'+(i+'').padStart(2,0)+(j+'').padStart(2,0),al: 'center',width: 160,fixed: false,show: this.showQuarterHour})
            } else {

              list.push({name: 'value'+(i+'').padStart(2,0)+(j+'').padStart(2,0),key: 'value'+(i+'').padStart(2,0)+(j+'').padStart(2,0),al: 'center',width: 160,fixed: false,show: this.showTwelfthHour})
            }
          }
        }
        return list
      },

      columns2 () {
        let list=[]
        list.push({name: '变量名称',key: 'variablename',al: 'left',width: 400,fixed: true})
        list.push({name: '月',key: 'mon',al: 'center',width: 50,fixed: true})
        list.push({name: 'next',key: 'next',al: 'center',width: 160,fixed: false})
        for(let i=1;i<=31;i++) {
          list.push({name: 'value'+i,key: 'value'+i,al: 'center',width: 160,fixed: false})
        }
        return list
      }
    },

    watch: {
      queryInput () {
        this.currentPage=1
        this.debounce(this.getList(),200)
      },

      value1 () {
        this.getList()
      },

      value2 () {
        this.getList()
      },

      activeName () {
        this.currentPage=1
        this.getList()
      },

      timeInterval (newVal,oldVal) {
        if(this.activeName==='historyex') {
          switch(newVal) {
            case 0:
              this.showHour=true
              this.showHalfHour=true
              this.showQuarterHour=true
              this.showTwelfthHour=true
              break;
            case 1:
              this.showHour=true
              this.showHalfHour=true
              this.showQuarterHour=true
              this.showTwelfthHour=false
              break;
            case 2:
              this.showHour=true
              this.showHalfHour=true
              this.showQuarterHour=false
              this.showTwelfthHour=false
              break;
            case 3:
              this.showHour=true
              this.showHalfHour=false
              this.showQuarterHour=false
              this.showTwelfthHour=false
              break;
          }
          this.getList()
        }
      }
    },

    mounted () {
      this.getList();//获取列表数据  
    },

    methods: {
      parseTime (time,cFormat) {
        if(arguments.length===0) {
          return null
        }
        const format=cFormat||'{y}-{m}-{d} {h}:{i}:{s}'
        let date
        if(typeof time==='object') {
          date=time
        } else {
          if((typeof time==='string')&&(/^[0-9]+$/.test(time))) {
            time=parseInt(time)
          }
          if((typeof time==='number')&&(time.toString().length===10)) {
            time=time*1000
          }
          date=new Date(time)
        }
        const formatObj={
          y: date.getFullYear(),
          m: date.getMonth()+1,
          d: date.getDate(),
          h: date.getHours(),
          i: date.getMinutes(),
          s: date.getSeconds(),
          a: date.getDay()
        }
        const time_str=format.replace(/{([ymdhisa])+}/g,(result,key) => {
          const value=formatObj[key]
          // Note: getDay() returns 0 on Sunday
          if(key==='a') {return ['日','一','二','三','四','五','六'][value]}
          return value.toString().padStart(2,'0')
        })
        return time_str
      },

      debounce (func,wait,immediate) {
        let timeout,args,context,timestamp,result

        const later=function() {
          // 据上一次触发时间间隔
          const last=+new Date()-timestamp

          // 上次被包装函数被调用时间间隔 last 小于设定时间间隔 wait
          if(last<wait&&last>0) {
            timeout=setTimeout(later,wait-last)
          } else {
            timeout=null
            // 如果设定为immediate===true，因为开始边界已经调用过了此处无需调用
            if(!immediate) {
              result=func.apply(context,args)
              if(!timeout) context=args=null
            }
          }
        }

        return function(...args) {
          context=this
          timestamp=+new Date()
          const callNow=immediate&&!timeout
          // 如果延时不存在，重新设定延时
          if(!timeout) timeout=setTimeout(later,wait)
          if(callNow) {
            result=func.apply(context,args)
            context=args=null
          }

          return result
        }
      },

      handleSizeChange (s) {
        this.currentSize=s
        this.currentPage=1
        this.getList()
      },

      handleCurrentChange (p) {
        this.currentPage=p
        this.getList()
      },

      // 月
      row_fn2 (key,i,e) {
        console.log(e)
        if(key.indexOf('value')!=-1||key.indexOf('next')!=-1) {
          this.flag2=key+i;
        }
      },

      // 日
      row_fn (key,i) {
        if(key.indexOf('value')!=-1||key.indexOf('next')!=-1) {
          this.flag=key+i;
        }
      },

      // 选择回调
      handleSelectionChange (v) {
        console.log(v);
        this.multipleSelection=v
      },

      // 清空选择
      clearSelection () {
        this.$refs.table.clearSelection()
        this.$refs.table2.clearSelection()
      },

      // 获取列表数据
      async getList () {
        if(this.activeName==='historyex') {
          this.loading=true;
          await this.$api.manualInputVariableApi.getHistoryexList(this.value1,this.timeInterval,this.currentPage,this.currentSize,this.queryInput,res => {
            if(res.data) {
              this.tableData=res.data
              this.total=res.total
              this.loading=false
              this.$nextTick(() => {
                this.$refs.table.bodyWrapper.scrollLeft=0
              })
            }
          })
        } else {
          this.loading=true
          await this.$api.manualInputVariableApi.getHistorydayList(this.value2,this.currentPage,this.currentSize,this.queryInput,res => {
            if(res.data) {
              this.tableData=res.data
              this.total=res.total
              this.loading=false
              this.$nextTick(() => {
                this.$refs.table2.bodyWrapper.scrollLeft=0
              })
            }
          })
        }
      },

      // 导出
      handleExportHistoryExcel () {
        if(isempty(this.multipleSelection)) {
          this.$message.warning("请选择有效数据")
          return
        }
        var vo={
          date: '',
          list: this.multipleSelection,
          tabType: this.activeName
        }
        this.$api.manualInputVariableApi.exportHistoryExcel(vo,res => {
          saveAs(`${DWSystemSetting.downloadUrl}${res}`,'历史数据.xls')
        })
        this.clearSelection()
      },

      // 点击上传
      handleUploadSuccess (response,file,fileList) {
        console.log(response,file,fileList)
        if(response.success) {
          let list=response.data
          list.forEach(element => {
            let currentIdIndex=this.tableData.findIndex(item => item.variablename===element.variablename)
            if(currentIdIndex!=-1) {
              this.tableData.splice(currentIdIndex,1,element)
            } else {
              this.tableData.push(element)
            }
          })
        }
      },

      // 更新到历史库
      handleUpdateHistoryValue () {
        if(isempty(this.multipleSelection)) {
          this.$message.warning("请选择有效数据")
          return
        }
        var date=''
        if(this.activeName==='historyex') {
          date=this.value1
        } else if(this.activeName==='historyday') {
          date=this.value2
        }
        var vo={
          date: date,
          list: this.multipleSelection,
          tabType: this.activeName
        }
        this.$api.manualInputVariableApi.saveHistory(vo,res => {
          console.log(res)
        })
        this.clearSelection()
      },

      // 差值转换成累加值
      handleToAccumulateValue () {
        if(isempty(this.multipleSelection)) {
          this.$message.warning("请选择有效数据")
          return
        }
        var date=''
        if(this.activeName==='historyex') {
          date=this.value1
        } else if(this.activeName==='historyday') {
          date=this.value2
        }
        var vo={
          date: date,
          list: this.multipleSelection,
          tabType: this.activeName
        }
        this.$api.manualInputVariableApi.toAccumulateValue(vo,res => {
          console.log(res)
          res.forEach(element => {
            let currentIdIndex=this.tableData.findIndex(item => item.variablename===element.variablename)
            this.tableData.splice(currentIdIndex,1,element)
          })
        })
        this.clearSelection()
      },

      // 根据首尾自动平均
      handleAvgByStartAndNext () {
        if(isempty(this.multipleSelection)) {
          this.$message.warning("请选择有效数据")
          return
        }
        var date=''
        if(this.activeName==='historyex') {
          date=this.value1
        } else if(this.activeName==='historyday') {
          date=this.value2
        }
        var vo={
          date: date,
          list: this.multipleSelection,
          tabType: this.activeName
        }
        this.$api.manualInputVariableApi.getAvgByStartAndNext(vo,res => {
          console.log(res)
          res.forEach(element => {
            let currentIdIndex=this.tableData.findIndex(item => item.variablename===element.variablename)
            this.tableData.splice(currentIdIndex,1,element)
          })
        })
        this.clearSelection()
      },

      // 根据两值自动增量
      handleStartTwoValueToAdd () {
        if(isempty(this.multipleSelection)) {
          this.$message.warning("请选择有效数据")
          return
        }
        var date=''
        if(this.activeName==='historyex') {
          date=this.value1
        } else if(this.activeName==='historyday') {
          date=this.value2
        }
        var vo={
          date: date,
          list: this.multipleSelection,
          tabType: this.activeName
        }
        this.$api.manualInputVariableApi.getStartTwoValueToAdd(vo,res => {
          console.log(res)
          res.forEach(element => {
            let currentIdIndex=this.tableData.findIndex(item => item.variablename===element.variablename)
            this.tableData.splice(currentIdIndex,1,element)
          })
        })
        this.clearSelection()
      }
    }
  };
</script>

<style lang="scss" scoped>
  .box {
    display: inline-block;
    margin-bottom: 10px;
    margin-right: 10px;
  }

  .radio_box {
    border: 1px solid #d7d7d7;
    border-radius: 5px;
    padding: 5px 3px;

    .el-radio {
      margin-right: 3px;
    }
  }

  .avatar {
    width: 30px;
    height: 30px;
    object-fit: cover;
  }

  .el-icon-d-arrow-left {
    position: absolute;
    right: 0;
    top: 300px;
    z-index: 1;
    font-size: 28px;
    cursor: pointer;
    background: #d7d7d7;
    clip-path: polygon(-18px 35px,
        26px 100%,
        calc(100% - 1px) 100%,
        calc(100% - 0px) 0);
    height: 70px;
    line-height: 70px;
    color: #666;
  }

  .el-icon-d-arrow-right {
    position: absolute;
    left: 0;
    top: 300px;
    z-index: 1;
    font-size: 28px;
    cursor: pointer;
    background: #d7d7d7;
    clip-path: polygon(0 0,
        1px 100%,
        calc(100% - 26px) 100%,
        calc(100% - -27px) 31px);
    height: 70px;
    line-height: 70px;
    color: #666;
  }

  .wrapper {
    width: 100%;
    height: 500px;
  }

  .pagination_box {
    display: flex;
    justify-content: flex-end;
    margin-top: 5px;
  }
</style>